import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../html/button'
import { Element } from '../../html/element'
import { Icon } from '../../html/icon'
import { BUTTON_TYPES, BUTTON_TYPES_OPTIONS } from './constants'
import classes from './index.module.scss'

export const ButtonCheckoutCustom = ({ type, className, disable, onClick }) => {
  const getButtonOptions = useMemo(() => {
    return BUTTON_TYPES_OPTIONS[type]
  }, [type])

  const onHandleClick = () => {
    if (disable || type === BUTTON_TYPES.UNAVAILABLE) return
    onClick()
  }

  const renderButtonLabel = () => {
    return (
      <div className="dFlex alignItemsCenter">
        <Icon
          className={getButtonOptions.icon}
          style={{
            color: disable ? '#9C9C9C' : getButtonOptions.iconColor,
            fontSize: 14,
          }}
        />
        <Element
          elementName="span"
          className="ml1"
          style={{ color: disable ? '#9C9C9C' : getButtonOptions.labelColor }}
        >
          <Translate value={getButtonOptions.label} />
        </Element>
      </div>
    )
  }

  return (
    <Button
      label={renderButtonLabel()}
      style={{
        backgroundColor: disable
          ? '#D5D5D5'
          : getButtonOptions.buttonBackgroundColor,
        ...getButtonOptions.buttonStyle,
      }}
      className={[className, classes.buttonCommon].join(' ')}
      action={onHandleClick}
    />
  )
}

ButtonCheckoutCustom.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  disable: PropTypes.bool,
  onClick: PropTypes.func,
}

ButtonCheckoutCustom.defaultProps = {
  type: BUTTON_TYPES.ADD_TO_CART,
  className: '',
  disable: false,
  onClick: () => {},
}
